import { isEmpty } from './helpers/isEmpty.js';

/**
 * Expresión regular para el formateo de email
 */
const EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

/**
 * Devuelve true si
 * - no valor
 * - el formato es correcto
 *
 * @param {string} value el valor
 * @returns {boolean} true === valido
 */
export function email(value) {
  if (isEmpty(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  return EMAIL_REGEXP.test(value);
}
